"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function addHttpIfNeeded(url) {
  var reg = /^http.?:\/\//;
  if (url && !reg.test(url)) {
    return "http://".concat(url);
  }
  return url;
}
var _default = exports["default"] = addHttpIfNeeded;